import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const PayoffInventory = ({ rows }) => {
  const [open, setOpen] = useState(false);
  if (!rows.length) return null;
  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid="data-inventory-toggle"
        className="inline-flex items-center gap-1.5 text-cyan-200/80 hover:text-white text-sm font-semibold transition-colors"
      >
        {open ? "Hide the numbers" : "See all the numbers"}
        <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="inv"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
            data-testid="data-inventory"
          >
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-0 bg-white/[0.03] rounded-2xl border border-white/10 px-5 py-3">
              {rows.map(([label, value]) => (
                <div key={label} className="flex items-baseline justify-between py-2 border-b border-white/5">
                  <span className="text-slate-400 text-xs md:text-sm">{label}</span>
                  <span className="text-white text-xs md:text-sm font-semibold tabular-nums">{value}</span>
                </div>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
